import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { graphqlClient } from "./api/graphql/config";
import ProjectRoutes from "./pages";
import { ConfigProvider } from "antd";
import { UserProvider } from './context/UserContext';
import { antdTheme } from "./styles/antdTheme";

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <ApolloProvider client={graphqlClient}>
        <UserProvider>
          <Router>
            <ProjectRoutes />
          </Router>
        </UserProvider>
      </ApolloProvider>
    </ConfigProvider>
  );
}

export default App;
